module.exports = __webpack_public_path__ + "img/disagree.3f6268bc.svg";